function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import Transition from 'react-transition-group/Transition';
import "./LoadingOverlay.css";

var LoadingOverlay =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(LoadingOverlay, _Component);

  function LoadingOverlay() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleExit = function () {
      if (_this.props.onLoadingStop) {
        _this.props.onLoadingStop();
      }
    };

    _this.renderOverlay = function (state) {
      if (state === 'exited') {
        return false;
      }

      var transitionStyles = {
        entered: {
          'in': true
        }
      };
      var loadingClasses = classNames('LoadingOverlay', 'fade', transitionStyles[state]);
      return React.createElement("div", {
        role: "status",
        className: loadingClasses
      }, React.createElement("ul", {
        "aria-hidden": true,
        className: "LoadingOverlay__ul"
      }, React.createElement("li", {
        className: "LoadingOverlay__li LoadingOverlay__li--1 bg-brand"
      }), React.createElement("li", {
        className: "LoadingOverlay__li LoadingOverlay__li--2 bg-brand"
      }), React.createElement("li", {
        className: "LoadingOverlay__li LoadingOverlay__li--3 bg-brand"
      }), React.createElement("li", {
        className: "LoadingOverlay__li LoadingOverlay__li--4 bg-brand"
      })));
    };

    return _this;
  }

  var _proto = LoadingOverlay.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        loading = _this$props.loading,
        transition = _this$props.transition,
        transitionAppear = _this$props.transitionAppear;
    return React.createElement(Transition, {
      appear: transitionAppear && transition,
      in: loading,
      timeout: 500,
      onExited: this.handleExit,
      enter: transition,
      exit: transition,
      unmountOnExit: true
    }, function (state) {
      return _this2.renderOverlay(state);
    });
  };

  return LoadingOverlay;
}(Component);

LoadingOverlay.propTypes = {
  /** Flag for displaying LoadingOverlay.  */
  loading: PropTypes.bool,

  /** Optional event handler to fire after a LoadingOverlay has been dismissed */
  onLoadingStop: PropTypes.func,

  /** Flag for enabling transitions */
  transition: PropTypes.bool,

  /** Option Flag for enabling transitions when the component appears */
  transitionAppear: PropTypes.bool
};
LoadingOverlay.defaultProps = {
  transition: true,
  transitionAppear: true,
  loading: true
};
export default LoadingOverlay;
//# sourceMappingURL=LoadingOverlay.js.map